import React, { Component } from 'react';
import axios from 'axios';

import { formatMoney, truncateAtFirstComma } from '../utils/utils.js';

require(`../assets/${process.env.PAGE}/css/components/CheckOut.css`);
class Summary extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };

    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                this.setState({
                    'requested_amount': data.requested_amount,
                    'capital_amount': data.capital_amount,
                    'average_car_amount': data.average_car_amount,
                    'car_brand': data.car_brand,
                    'car_model': data.car_model,
                    'car_price': data.car_price,
                    'car_loan_installment': data.car_loan_installment,
                    'offer_type': data.offer_type,
                    'car_year': data.car_year,
                    'car_version': data.car_version
                });
            }
            );
    }

    renderSummaryItem(label, value) {
        return (
            <div className="summary-item">
                <div className="summary-content">
                    <h4 className="summary-label">
                        <span className="summary-arrow">→</span> {label}
                    </h4>
                    <div className="summary-value">{value}</div>
                </div>
            </div>
        );
    }

    render() {

        const {
            requested_amount,
            capital_amount,
            average_car_amount,
            car_brand,
            car_model,
            car_loan_installment,
            offer_type,
            car_year,
            car_version
        } = this.state;

        const installment_amount = typeof (requested_amount) !== 'undefined' ? formatMoney(requested_amount, 0, ',', '.') : '';

        const capital = typeof (capital_amount) !== 'undefined' ? formatMoney(capital_amount, 0, ',', '.') : '$ 0';

        const average_amount = typeof (average_car_amount) !== 'undefined' ? formatMoney(average_car_amount, 0, ',', '.') : '';

        // Auto Seleccionado content
        const autoContent = (
            <div>
                <div><strong>Marca</strong> {car_brand || 'Fiat'}</div>
                <div><strong>Modelo</strong> {car_model || 'Pulse'}</div>
                <div><strong>Año</strong> {car_year || '2020'}</div>
                <div><strong>Versión</strong> {car_version || 'Pulse'}</div>
            </div>
        );

        // Tipo de financiación content
        let financingType = offer_type || 'Contado';
        if (car_loan_installment && car_loan_installment.length > 0) {
            const displayValue = offer_type === "Financiado"
                ? truncateAtFirstComma(car_loan_installment[0])
                : car_loan_installment[0];
            financingType = `${offer_type} / ${displayValue}`;
        }

        return (
            <div className="summary-container-new">
                {this.renderSummaryItem('Auto Seleccionado', autoContent)}
                {this.renderSummaryItem('Capital a invertir', capital)}
                {average_amount && this.renderSummaryItem('Usado Valor Estimado', average_amount)}
                {installment_amount && this.renderSummaryItem('Monto de las cuotas', installment_amount)}
                {this.renderSummaryItem('Tipo de financiación', financingType)}
                <div className="car-offer-description">
                    <p>Esto es una estimación completa del valor de su vehículo, junto con la financiación que queda sujeta a tu evaluación crediticia.</p>
                </div>
            </div>
        );
    }
}

export default Summary;



/** WEBPACK FOOTER **
 ** ./src/components/Summary.js
 **/